import { render, staticRenderFns } from "./PracticeExamMap.vue?vue&type=template&id=2ca00942&scoped=true&"
import script from "./PracticeExamMap.vue?vue&type=script&lang=js&"
export * from "./PracticeExamMap.vue?vue&type=script&lang=js&"
import style1 from "./PracticeExamMap.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca00942",
  null
  
)

export default component.exports